import React, { useContext } from 'react';
// context
import { GlobalDispatchContext } from 'src/@app/providers/GlobalStateProvider';
// @auth
import { updateUserConfig } from 'src/@auth';
import { signOut } from 'src/@auth/functions/core';
// ts
import { INavBarLink, IRouteItem } from 'src/@app/props';
// context
import { useLanguageSelectors, useConfigSelectors } from 'src/@app/reducers';
import { getDeployedProductId, removeAvailableFilters, ignoreSavedFilters } from 'src/utils';
// common components
import { NavBar, Icons } from '@ems/client-design-system';
import { NavLink } from 'react-router-dom';
import { routes } from 'src/screens/routes';
// comment out, not remove because we will put this back
// TODO: for the basic logout experience, we add a simple logout page/route for now
// import { externalRoutes } from 'src/screens/externalRoutes';

export const NavBarContainer = () => {
  const dispatcher = useContext(GlobalDispatchContext);
  const configSelectors = useConfigSelectors();
  const isPortrait = configSelectors.getIfPortraitLayout();
  const availableRoutes = configSelectors.getAvailableRoutes();

  // Translation
  const languageSelectors = useLanguageSelectors();
  const {
    components: {
      headings: { anomsx, logout },
      hints: { areYouSureToLogout },
      lists: { navBarList },
    },
  } = languageSelectors.getLanguage();

  const logoIcon = <Icons title={``} iconName="ic-a-logo" className="ic-a-logo" size="20" />;

  const LinkComponent = ({ children, ...props }: any) => (
    <NavLink activeClassName="navbar-selected" {...props}>
      {children}
    </NavLink>
  );

  const mainLinks: INavBarLink[] = [];
  routes
    .filter(
      (current: IRouteItem) =>
        current.navBarPosition === 'header' && availableRoutes.includes(current.route)
    )
    .map((current: IRouteItem) => {
      mainLinks.push({
        key: current.route,
        name: navBarList[current.route],
        icon: current.icon,
        link: `/${getDeployedProductId()}/${current.route}`,
        onClick: () => {
          ignoreSavedFilters();
        },
      });
    });

  const footerLinks: INavBarLink[] = [];
  routes
    .filter(
      (current: IRouteItem) =>
        current.navBarPosition === 'footer' && availableRoutes.includes(current.route)
    )
    .map((current: IRouteItem) => {
      footerLinks.push({
        key: current.route,
        name: navBarList[current.route],
        icon: current.icon,
        link: `/${getDeployedProductId()}/${current.route}`,
      });
    });

  // externalRoutes
  //   .filter((current: IRouteItem) => current.navBarPosition === 'footer')
  //   .map((current: any) => {
  //     footerLinks.push({
  //       name: navBarList[current.route],
  //       icon: current.icon,
  //       link: current.link,
  //       isExternal: true,
  //     });
  //   });

  footerLinks.push({
    key: 'switchLayout',
    name: 'Switch layout',
    icon: (
      <Icons title={logout} iconName="ic-ui-page-layout" className="ic-ui-page-layout" size="20" />
    ),
    link: 'switchLayout',
    onClick: (event: any) => {
      event.preventDefault();
      updateUserConfig(dispatcher, {
        isPortrait: !isPortrait,
      });
    },
  });

  // TODO: for the basic logout experience, we add a simple logout page/route for now
  footerLinks.push({
    key: 'logout',
    name: logout,
    icon: <Icons title={logout} iconName="ic-ui-logout" className="ic-ui-logout" size="20" />,
    link: logout,
    closeOnClick: false,
    onClick: (event: any) => {
      event.preventDefault();
      if (confirm(areYouSureToLogout)) {
        removeAvailableFilters();
        signOut();
      }
    },
  });

  // related functions for package info -> appVersion, appBuild, appTimestamp, appBuildDateTime

  return (
    <>
      <NavBar
        productInfo={{
          name: anomsx,
          icon: logoIcon,
        }}
        displayTitle={false}
        primaryLinks={mainLinks}
        footerLinks={footerLinks}
        LinkComponent={LinkComponent}
      />
    </>
  );
};
